import { Pagination, Form } from "react-bootstrap"
import type { usePaginator } from "./usePaginator"


const Paginator = ({ paginator }: { paginator: ReturnType<typeof usePaginator> }) => {
    const currentPage = Math.floor(paginator.state.offset / paginator.state.limit) + 1
    const hasPrev = paginator.state.offset > 0
    const hasNext = paginator.state.sizeOfCurrentPage >= paginator.state.limit;
    return (
        <nav aria-label="Page navigation">
            <Pagination className="mb-0 d-flex align-items-end justify-content-end">
                <Pagination.Item disabled={!hasPrev} onClick={paginator.events.triggerPrev}>
                    <i className="bi bi-chevron-left"></i>
                </Pagination.Item>
                <Pagination.Item active>{currentPage}</Pagination.Item>
                <Pagination.Item disabled={!hasNext} onClick={paginator.events.triggerNext}>
                    <i className="bi bi-chevron-right"></i>
                </Pagination.Item>
                <li className="ms-3" style={{ height: 38 }}>
                    <Form.Select
                        className="h-100"
                        onChange={(e) => paginator.events.setLimit(Number(e.target.value))}
                        value={paginator.state.limit}
                    >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={15}>15</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </Form.Select>
                </li>
            </Pagination>
        </nav>
    )
}

export default Paginator
